module.exports = __webpack_public_path__ + "static/media/mock-washinn2.8c0e0aa8.png";